export default __webpack_public_path__ + "static/media/industry-solid-full-brown.94422557.svg";